/* LoginPage — Branded sign-in screen */

.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: var(--space-4);
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--color-primary) 8%, transparent) 0%,
    var(--color-bg) 40%
  );
}

.logo {
  width: 200px;
  height: auto;
  margin-bottom: var(--space-6);
}

.heading {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-primary);
  margin-bottom: var(--space-2);
}

.tagline {
  color: var(--color-text-secondary);
  font-size: var(--font-size-base);
  margin-bottom: var(--space-8);
}

.error {
  color: var(--color-error);
  font-size: var(--font-size-sm);
  margin-top: var(--space-4);
  max-width: 400px;
  text-align: center;
}

.footer {
  position: absolute;
  bottom: var(--space-6);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}
